import { render, staticRenderFns } from "./CardPosition.vue?vue&type=template&id=a20ed9c6&scoped=true&"
import script from "./CardPosition.vue?vue&type=script&lang=js&"
export * from "./CardPosition.vue?vue&type=script&lang=js&"
import style0 from "./CardPosition.vue?vue&type=style&index=0&id=a20ed9c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20ed9c6",
  null
  
)

export default component.exports